module.exports = __webpack_public_path__ + "img/SecurityHelmet.15799e20.png";